import type { Handlers, WorkerConfigSyncBCName, WorkerConfigSyncEvent, } from "owa-worker-config-sync-types";
import type { TraceErrorObject } from "owa-analytics-types";
import type { ThreadName } from "owa-thread-config";
import { trace } from "owa-trace";
import { getUuidV4 } from "owa-guid";

let bc: BroadcastChannel | null = null;
let workerConfigSyncScopeId: string | undefined;

export function getWorkerConfigSyncScopeId(): string {
    return (workerConfigSyncScopeId ??= getUuidV4());
}

function getBroadcastChannel(): BroadcastChannel | null {
    if (!bc && typeof BroadcastChannel !== "undefined") {
        bc = new BroadcastChannel("worker-config-sync" as WorkerConfigSyncBCName);
    }
    
    return bc;
}

/**
 * We need to use a BroadcastChannel to send messages to the workers because Monarch windows
 * don't share the
 */

export async function sendConfigToWorkers(workers: "all" | ThreadName[], handler: Handlers, value: any, scopeId?: string): Promise<void> {
    try {
        trace.info(`[config-sync] Sending "${handler}" config to "${Array.isArray(workers) ? workers.join(", ") : workers}" worker(s)`, "analytics");
        
        const message: WorkerConfigSyncEvent = {
            executeOn: workers,
            handler,
            value,
            scopeId,
        };
        
        getBroadcastChannel()?.postMessage(message);
    }
    catch (error) {
        // Errors resulting from enabling useUnknownInCatchVariables
        // TS2322: Type 'unknown' is not assignable to type 'TraceErrorObject'.
        // @ts-expect-error
        const err: TraceErrorObject = error;
        err.additionalInfo = {
            executeOn: workers,
            handler,
            value,
        };
        throw err;
    }
}
